export default () => ({
  paymentForm: ''
});
